/*********************************************************
 * Copyright (C) 2015 VMware, Inc. All rights reserved.
 *********************************************************/
/**
 * @fileoverview typedarraysupport.js -- Uint8Array.from, Int16Array.from
 * In some browsers there are some browser APIs missing(like chrome < 45),
 * so we use this file to define a simple version of these functions which
 * are enough for us to use.
 */

'use strict';

/*global Int16Array, Uint8Array, Array*/

(function() {
   var appendFunction = function(ArrayClass, data) {
      var i,
         typedArray;
      if (!data || !data.length) {
         return null;
      }
      typedArray = new ArrayClass(data.length);
      for (i = 0; i < data.length; i++) {
         typedArray[i] = data[i];
      }
      return typedArray;
   };

   if (!Uint8Array.from) {
      Uint8Array.from = function(data) {
         return appendFunction(Uint8Array, data);
      };
   }
   if (!Int16Array.from) {
      Int16Array.from = function(data) {
         return appendFunction(Int16Array, data);
      };
   }
   if (!Array.from) {
      Array.from = function(data) {
         return appendFunction(Array, data);
      };
   }
}());